import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Parse a string or number to a safe integer, returning 0 for nullish/NaN values. */
export function num(val: string | number | undefined | null): number {
  if (val == null) return 0;
  return typeof val === 'number' ? val : parseInt(val, 10) || 0;
}
